import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'lms-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {
 // pollingService = inject(NotificationService);
constructor() { }
//   this.notificationService.stream$.subscribe(event => {
//   this.highlightedId = event.target;
//   this.highlightType = event.type;

//   // Auto-clear after 2 seconds
//   setTimeout(() => {
//     this.highlightedId = null;
//     this.highlightType = 'none';
//   }, 2000);
// });
  ngOnInit(): void {

  }

  ngOnDestroy(): void {
  }

}
